import type { FC } from 'react';
import { Input } from 'src/common/components/input';
import { bindDataTestId, TestIds } from 'src/utils/qa-utils';

import { SettingModalCommon, SettingProvider } from '../common';
import { useModel } from 'src/common/create-model';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

export const SpaceName: FC = () => {
  const { t } = useAppTranslation();
  const {
    spaceSettingState: { spaceName, setSpaceName, saveSpaceSetting },
  } = useModel(SettingProvider);
  return (
    <>
      <SettingModalCommon.SettingDivider className="mb-2.5" />
      <div className={SettingModalCommon.commonStyles.name}>
        {t('components.setting_modal.space_setting.space_name.title')}
      </div>
      <Input
        {...bindDataTestId(TestIds.settingSpaceInput)}
        maxLength={55}
        placeholder={t('components.setting_modal.space_setting.space_name.placeholder')}
        className={SettingModalCommon.commonStyles.input}
        value={spaceName || ''}
        onChange={(str) => setSpaceName(str || '')}
        onEnter={saveSpaceSetting}
      />
    </>
  );
};
